import { MBIconV2Name } from '@shared/components/image';
import { isRelatedCardComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class RelatedCardFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<MBAPI.WorkflowTemplate_components_RelatedCardComponent>,
  ) {}

  matchesComponent(
    component: MBAPI.WorkflowTemplate_components,
    _reservedIds: Array<string>,
  ): boolean {
    return isRelatedCardComponent(component);
  }

  canBeAdded(_components: MBAPI.WorkflowTemplate_components[]): boolean {
    return true;
  }
}
